export default __webpack_public_path__ + "static/Plots0029-567d6a68941c07bdcf0acc7b81b34f28.jpg";